import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, AlertTitle, Button } from '@mui/material';

const formatCOP = (value) => new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 }).format(value);

// Sin saldo positivo el backend rechaza cualquier reserva nueva (check_user_balance).
export const puedeReservar = (balance) => Number(balance) > 0;

/**
 * Aviso para billeteras en cero o en deuda.
 * `showRechargeButton` lleva a Mi Billetera; se omite cuando ya se está ahí.
 */
const SaldoInsuficienteAlert = ({ balance, showRechargeButton = true, sx }) => {
  const navigate = useNavigate();
  const value = Number(balance) || 0;
  if (puedeReservar(value)) return null;

  const enDeuda = value < 0;

  return (
    <Alert
      severity={enDeuda ? 'error' : 'warning'}
      sx={{ borderRadius: 3, ...sx }}
      action={showRechargeButton && (
        <Button color="inherit" size="small" onClick={() => navigate('/mi-billetera')}>
          Recargar
        </Button>
      )}
    >
      <AlertTitle>{enDeuda ? 'Tienes una deuda pendiente' : 'No tienes saldo'}</AlertTitle>
      {enDeuda
        ? `Tu billetera tiene una deuda de $${formatCOP(Math.abs(value))}. No podrás hacer reservas hasta que recargues y tu saldo quede positivo.`
        : 'Tu billetera está en $0. Recarga saldo para poder hacer reservas.'}
    </Alert>
  );
};

export default SaldoInsuficienteAlert;
